export const getBaseUrlFromSocket = (url) => {
    if (url.includes('://api.')) {
        const position = url.indexOf('/socket.io');
        if (position !== -1) {
            return url.substring(0, position);
        }
        return url;
    }

    const position = url.indexOf('/socket.io');
    if (position !== -1) {
        return url.substring(0, position) + '/api';
    }
    return url + '/api';
};
